import React from "react";
import "../css/dashboard.css";
import TopTitleBannerMobile from "../component/TopTitleBannerMobile";
import CollapseComponentMobile from "../component/Misc/CollapseComponentMobile";

export default function DocumentsContent() {

  // useEffect(() => {
  //   if (currentUser?.email) {
  //     recordMetrics(
  //       "Documents",
  //       "pageLoad",
  //       currentUser.email,
  //       "read",
  //       "bodhi"
  //     );
  //   }
  // }, [currentUser.email]);
  return (
    <div className="right-container">
      <TopTitleBannerMobile title={"Documents"} />
      <CollapseComponentMobile />
    </div>
  );
}
